<template>
  <common-dashboard-card-template
    :isDataFound="docs && docs.length"
    @viewMore="$emit('viewMore')"
  >
    <template #header>
      <div class="flex-row flex__left">
        <span class="margin-right-15 font-size__large">
          <template v-if="unreadDocCount !== undefined">
            <el-badge :value="unreadDocCount > 9 ? '+9' : `${unreadDocCount}`">
              <i class="far fa-inbox-out fa-fw color__white"></i>
            </el-badge>
          </template>
          <template v-else>
            <i class="far fa-inbox-out fa-fw color__white"></i>
          </template>
        </span>
        <h3 class="tt1 color__white">{{ cardTitle }}</h3>
      </div>
    </template>

    <template #body>
      <div v-if="docs && docs.length">
        <template v-for="item in docs">
          <doc-dashboard-card-item
            :key="getItemKeyFn(item)"
            :item="item"
            @click="itemClick(item)"
          ></doc-dashboard-card-item>
        </template>
      </div>
    </template>
  </common-dashboard-card-template>
</template>
<script>
  import CommonDashboardCardTemplate from "../common/layout/common-dashboard-card-template";
  import DocDashboardCardItem from "./doc-dashboard-card-item";

  export default {
    name: "doc-out-dashboard-card-v2",
    props: ["cardTitle", "docs", "docsCount", "unreadDocCount", "getItemKeyFn"],
    components: {
      DocDashboardCardItem,
      CommonDashboardCardTemplate,
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
    },
    methods: {
      itemClick(item) {
        this.$emit("viewDetail", {doc: item});
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/dashboard/doc-out-dashboard-card-v2.vue